import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaAngleRight } from "react-icons/fa6";
import "./top-client-pass-form.css";
import axios from "axios";
import Swal from "sweetalert2";
import { modalCreditClient } from "../../../components/heavy-header/heavy-header-service";

function CreditClientForm({ onSuccess }) {
  const [creditClientsArr, setCreditClientsArr] = useState([]);
  
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted }
  } = useForm({
    defaultValues: {
      credit_client: ""
    }
  });

  useEffect(() => {
    getData();
  },[]);

  const getData = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/setter/credit_client`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`
        },
      });

      console.log(response.data.data.credit_clients);
      setCreditClientsArr(response.data.data.credit_clients);

    } catch (error) {
      Swal.fire({
        title: "Error al obtener datos",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
      modalCreditClient.close();
      if (onSuccess) onSuccess("normal");
    }
  }

  const onSubmitForm = async (data) => {
    try {
      const selectedId = data.credit_client;

      const selectedClient = creditClientsArr.find(
        (item) => String(item.id) === String(selectedId)
      );
      
      if (selectedClient) {
        modalCreditClient.close();
        if (onSuccess) onSuccess("credit", selectedClient); 
      } else {
        throw new Error("Cliente no encontrado o inválido");
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Por favor, selecciona un cliente válido",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
      modalCreditClient.close();
      if (onSuccess) onSuccess("normal");
    }
  }

  return (
    <>
      <form
        className="pass-top-client-form"
        autoComplete="off"
        onSubmit={handleSubmit(onSubmitForm)}
      >
        <div className="heavy-form-group consignee-content">
          <select
            id="credit_client"
            className="formInput"
            {...register("credit_client", {
              required: true
            })}
          >
            <option value="">Selecciona una opción</option>
            {creditClientsArr.map((item, index) => (
              <option key={index} value={item.id}>{item.name}</option>
            ))}
          </select>
          
          {errors.credit_client?.type === "required" && isSubmitted && (
            <p className="text-alert" style={{color: 'red', margin: '5px 0 0 0', fontSize: '12px'}}>
              Este campo es requerido
            </p>
          )}
        </div>

        <div className="cont-btn-pass">
          <button type="submit">
            Siguiente <FaAngleRight />
          </button>
        </div>
      </form>
    </>
  )
}

export default CreditClientForm;